export class FiltersService {
  public filtersToQuery(filters: any) {
    return {
      dateStart: (filters.date && filters.date.start) || undefined,
      dateEnd: (filters.date && filters.date.end) || undefined,
      search: filters.search || undefined,
      logicalStructureId: filters.logicalStructureId || undefined,
      userId: filters.userId || undefined,
      tags: filters.tags && filters.tags.length ? filters.tags : undefined
    };
  }

  public queryToFilters(query: any) {
    return {
      search: query.search || undefined,
      userId: +query.userId || undefined,
      logicalStructureId: +query.logicalStructureId || undefined,
      date: this.queryDateToFilterDate(query),
      tags: this.parseTagsFromQuery(query.tags)
    };
  }

  private queryDateToFilterDate(query: any) {
    return {
      start: query.dateStart || undefined,
      end: query.dateEnd || undefined
    };
  }

  private parseTagsFromQuery(tags?: string[] | string) {
    if (!tags) {
      return [];
    }
    if (!Array.isArray(tags)) {
      return [+tags];
    }
    return tags.map(tag => +tag);
  }
}

export default new FiltersService();
